<template>
	<div class="row">
		<div class="col-sm-3 text-center" style="height: 164px">
			<CropImage
				path="icons-services"
				:crop="[132, 132]"
				v-model="data.icon"
			/>
			<div class="clearfix"></div>
		</div>
		<div class="col-sm-9" style="margin-top: 20px">
			<div class="row">
				<div class="col-sm-12">
					<span>Titulo</span>
					<input
						type="text"
						v-model="data.servico"
						class="form-control"
					/>
				</div>
				<div class="col-sm-4">
					<span>Código</span>
					<input
						type="text"
						v-model="data.cod"
						disabled
						class="form-control"
					/>
				</div>
				<div class="col-sm-4">
					<span>Sigla</span>
					<input
						type="text"
						v-model="data.sigla"
						class="form-control"
					/>
				</div>
				<div class="col-sm-4">
					<span>Valor</span>
					<div class="input-group">
						<span class="input-group-addon">R$</span>
						<input
							type="text"
							v-model="data.valor"
							class="form-control"
						/>
					</div>
				</div>
			</div>
		</div>
		<!--   <div class="col-sm-9">
                  <br>
                  <label class="checkbox-inline">
                        <input type="checkbox">
                        Contratual
                  </label>
                  <label class="checkbox-inline">
                        <input type="checkbox">
                        Interna
                  </label>
            </div> -->
	</div>
</template>
<script>
	import CropImage from 'app/cropImage';
	export default {
		name: 'SettingsServices',
		components: { CropImage },
		props: ['dIn'],
		computed: {
			data() {
				return this.dIn;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/services/configuracoes.vue